import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Es difícil?',
    a: 'Los primeros 3 días sí. Por eso el protocolo te da herramientas de choque específicas para ese periodo.'
  }, {
    q: '¿Qué pasa si recaigo?',
    a: "El manual incluye una sección de 'Control de Daños' para que una caída no se convierta en un colapso total."
  }, {
    q: '¿Necesito comprar equipo adicional?',
    a: 'No. Solo necesitas este PDF, disposición y quizás un cuaderno.'
  }, {
    q: '¿Es esto para siempre?',
    a: 'El protocolo es un reinicio de 21 días. Después de eso, tú decides cómo manejar tu nueva libertad.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-[#09090b]" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <FadeIn data-id="element-28">
          <h2 className="font-bebas text-4xl sm:text-5xl uppercase tracking-wide text-center mb-12" data-id="element-29">
            Preguntas <span className="text-amber-500" data-id="element-30">Frecuentes</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-31">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-32">
              <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden" data-id="element-33">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-34">
                  <span className="text-lg font-semibold text-white" data-id="element-35">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-zinc-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
                </button>
                <AnimatePresence data-id="element-37">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-38">
                      <div className="px-6 pb-6 text-zinc-400 leading-relaxed border-t border-zinc-800/50 pt-4" data-id="element-39">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}